const CHAR_SETS = {
  lower: 'abcdefghijklmnopqrstuvwxyz',
  upper: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ',
  numbers: '0123456789',
  symbols: '!@#$%^&*()_+-=[]{}|;:,.<>?',
}

// Ambiguous-looking characters some sites/people find confusing to type.
const AMBIGUOUS = 'Il1O0'

export const generatePassword = ({
  length,
  lower,
  upper,
  numbers,
  symbols,
  excludeAmbiguous,
}) => {
  let pool = ''
  if (lower) pool += CHAR_SETS.lower
  if (upper) pool += CHAR_SETS.upper
  if (numbers) pool += CHAR_SETS.numbers
  if (symbols) pool += CHAR_SETS.symbols
  if (!pool) pool = CHAR_SETS.lower

  if (excludeAmbiguous) {
    pool = [...pool].filter((c) => !AMBIGUOUS.includes(c)).join('')
  }

  const randomValues = new Uint32Array(length)
  window.crypto.getRandomValues(randomValues)

  return Array.from(randomValues, (n) => pool[n % pool.length]).join('')
}

// Rough entropy-based strength estimate (bits), not a rigorous audit.
export const passwordStrength = (password, poolSize) => {
  const bits = password.length * Math.log2(Math.max(poolSize, 2))
  if (bits < 40) return { label: 'Fraca', level: 1 }
  if (bits < 70) return { label: 'Razoável', level: 2 }
  if (bits < 100) return { label: 'Forte', level: 3 }
  return { label: 'Muito forte', level: 4 }
}

export const poolSizeFor = ({ lower, upper, numbers, symbols }) => {
  let size = 0
  if (lower) size += CHAR_SETS.lower.length
  if (upper) size += CHAR_SETS.upper.length
  if (numbers) size += CHAR_SETS.numbers.length
  if (symbols) size += CHAR_SETS.symbols.length
  return size || CHAR_SETS.lower.length
}
